import { gql } from "lib/apolloClient";

export const aiTutorListRowFragment = gql`
  fragment aiTutorListRow on Assessment {
    id
    title {
      id
      value
    }
    image {
      id
      value
    }
    taskType {
      id
      type
      label
    }
    grades {
      id
      name
    }
    fields(uids: ["subjects"]) {
      id
      uid
      resolvedMinimalTree {
        ... on ResolvedFieldSubjectSet {
          id
          subjects {
            id
            name
          }
        }
      }
    }
    createdBy {
      id
      firstName
      lastName
      profileImage
      isArchivedV2(filters: $userArchivedFilters)
    }
    createdAt
  }
`;

export const aiTutorAwardEntryFragment = gql`
  fragment aiTutorAwardEntryDetails on AiTutorAwardEntry {
    id
    category
    speciality
    description
    createdAt
    tutor {
      id
      title {
        id
        value
      }
      image {
        id
        value
      }
      grades {
        id
        name
      }
      fields(uids: ["subjects"]) {
        id
        uid
        resolvedMinimalTree {
          ... on ResolvedFieldSubjectSet {
            id
            subjects {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const aiTutorAwardEntryReviewFragment = gql`
  fragment aiTutorAwardEntryReview on AiTutorAwardEntry {
    id
    category
    speciality
    description
    review
    userEmail
    createdAt
    createdBy {
      id
      firstName
      lastName
      profileImage
      email
      displayRole
    }
    tutor {
      id
      title {
        id
        value
      }
      image {
        id
        value
      }
      metaData
      grades {
        id
        name
      }
      fields(uids: ["subjects"]) {
        id
        uid
        resolvedMinimalTree {
          ... on ResolvedFieldSubjectSet {
            id
            subjects {
              id
              name
            }
          }
        }
      }
    }
    attachments {
      id
      name
      type
      mimeType
      url
      thumbUrl
    }
  }
`;
